module.exports = __webpack_public_path__ + "img/UTGREE-5.a41408a1.jpg";